// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"9563f661","12":"04ba5642","373":"514911be","603":"0d33b3f5"}[chunkId] + ".chunk.js";
};